import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Substitute } from "../../models/substitute";
@Component({
    selector: "substitute-admin-grid",
    templateUrl: "./admin-grid.component.html",
    standalone: false
})
export class AdminGridComponent {
  @Input()
  public gridData: Substitute[];
  @Output()
  public editSubstitution = new EventEmitter<Substitute>();
  @Output()
  public deleteSubstitution = new EventEmitter<Substitute>();

  public onEdit(s: Substitute) {
    this.editSubstitution.next(s);
  }

  public onDelete(s: Substitute) {
    this.deleteSubstitution.next(s);
  }
}
